import { StateCreator } from "zustand";
import { IAppState, IAuthState } from '../types';

const createAuthSlice: StateCreator<
    IAppState,
    [["zustand/devtools", never], ["zustand/persist", unknown], ["zustand/immer", never]],
    [],
    IAuthState
    > = (set, get) => {
    return {
        auth: {
            token: null,
            email: '',
            expiresIn: null,
            phoneNumber: '',
            roleName: '',
            name: '',
            profilePicture: '',
        },
        setLoginInfo: (auth): void => {
            set(state => {
                state.auth = auth;
            })
        }
    }
};

export default createAuthSlice;